exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0e02517f]:export {\n  primary: #aa4121;\n  secondary: #ccc;\n  gray: #636363;\n}\n.seder .sedar-title-tab[data-v-0e02517f] {\n  background: #aa4121;\n  border-radius: 10px 10px 0 0;\n}\n.seder h5[data-v-0e02517f] {\n  color: #fff;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n.seder .sedar-dedication[data-v-0e02517f] {\n  color: #fff;\n  font-weight: bold;\n}", ""]);

// exports
